<template>
    <b-container fluid class="h-100 img-bg">
        <Agora_RTC ref="artc" :username="agora_uid" :channel="channel" :preferredinput="selectedDevice != null ? selectedDevice.deviceId : null" @stream-started="registerstream" @stream-stopped="unregisterstream" @audio-devices="gotDevices"></Agora_RTC>

        <b-modal ref="welcome-modal" size="xl"
                 no-close-on-esc
                 no-close-on-backdrop
                 hide-header-close
                 ok-only
                 centered>

            <template v-slot:default>
                <b-container fluid class="w-100">
                    <b-row no-gutters>
                        <b-col sm="8" class="body-content">
                            <h3>Benvenuto alla pagina di test</h3>
                            <ul>
                                <li>
                                    <h4> Sistema Operativo: </h4>
                                    {{ osinfo }}
                                </li>
                                <li>
                                    <h4> Browser: </h4>
                                    {{ browserinfo }}
                                    <div v-if="!browserOk" >
                                        <h5>Il browser in uso potrebbe non supportare alcune delle funzioni necessarie per la fruizione del tour</h5>
                                        Prova da desktop con:
                                        <ul>
                                            <li>Chrome v.80+, Firefox v.70+ su Windows (Edge v.80+ su Windows 10)</li>
                                            <li>Chrome v.80+, Firefox v.70+, Safari v.11+ su macOS</li>
                                        </ul>
                                        o mobile con:
                                        <ul>
                                            <li>Safari v.11+ su IOS</li>
                                            <li>Chrome v.80+ su Android</li>
                                        </ul>
                                    </div>

                                </li>
                                <li>
                                    <h4> Audio: </h4>
                                    <div>Assicurati che il volume dell'audio sia adeguato<br>(premi play per far partire un'audio di test)</div>
                                    <audio controls>
                                        <source src="sample.mp3" type="audio/mpeg">
                                        Questo Browser non supporta il tag 'audio'
                                    </audio>
                                </li>
                                <li >
                                    <h4> Microfono: </h4>
                                    <div v-if="audioInputDevices.length > 0">
                                        <div >Assicurati che il microfono sia acceso/collegato se vuoi fare delle domande alla guida<br>(Seleziona il microfono che intedi usare, premi play e prova a parlare, dovresti vedere una barra diventare verde accanto all'icona del microfono)</div>
                                        <b-button-toolbar key-nav aria-label="Toolbar with button groups">
                                            <b-form-select v-model="selectedDevice" :options="audioInputDevices" default="seleziona il microfono dall'elenco" size="sm"></b-form-select>
                                            <b-button size="sm" :disabled="mictestinterval !== null || !selectedDevice" variant="outline-dark"><b-icon-play-fill @click="startTestDevice"></b-icon-play-fill></b-button>
                                            <b-button size="sm" :disabled="mictestinterval === null" variant="outline-dark"><b-icon-stop-fill @click="stopTestDevice"></b-icon-stop-fill></b-button>
                                            <b-icon-mic-fill class="mt-2"></b-icon-mic-fill>
                                            <b-progress :value="audiotestlevel * 150" :max="100" class="mt-2" style="width:10%; min-width:100px;" variant="success"></b-progress>
                                        </b-button-toolbar>
                                        <div id="mic-test"></div>
                                    </div>
                                    <div v-else>
                                        <div >Nessun microfono trovato</div>
                                    </div>
                                </li>
                            </ul>
                        </b-col>
                    </b-row>
                </b-container>
            </template>

            <template v-slot:modal-header>
                <h2>Napoli Sotterranea Virtual Tour</h2>
            </template>

            <template v-slot:modal-footer>
                <div>
                    <b-link to="/home">Torna alla Home</b-link>
                </div>
                <SocialChat :attendants="attendants">
                    <p slot="header">Clicca su uno dei nostri operatori per chattare</p>
                    <template v-slot:button="{ open }">
                        <span v-show="!open">Contattaci</span>
                        <span v-show="open">Chiudi</span>
                    </template>
                    <small slot="footer">Orari Supporto: 9:00 to 18:00</small>
                </SocialChat>
            </template>
        </b-modal>

    </b-container>
</template>

<script>
    import moment from "moment";
    moment.locale('IT');

    import Bowser from "bowser";

    /*import Agora_RTM from './Agora_RTM';*/
    import Agora_RTC from './Agora_RTC';

    import { SocialChat } from 'vue-social-chat'


    export default {
        name: "Client",
        components: {
            /*Agora_RTM,*/
            Agora_RTC,
            SocialChat
        },
        props: ['ticket'],
        data: function () {
            return {
                uid: '',
                isvalid: false,
                isused: false,
                expired: false,
                channel: null,
                question_wtg: false,
                question_going: false,
                ready: false,
                guideReady: false,
                notyet: '',
                timeofevent: null,
                audioInputDevices: [],
                selectedDevice: null,
                audiotestlevel: 0,
                mictestinterval: null,
                currentnode: '',
                browserinfo: '',
                osinfo: '',
                browserOk: false,
                attendants: [
                    {
                        app: 'whatsapp',
                        label: 'Supporto Tecnico',
                        name: 'Help Chat',
                        number: '3923472581',
                        avatar: {
                            src: 'wapp_icon.jpg',
                            alt: 'Help Chat'
                        }
                    }
                ]
            }
        },
        computed:{
            agora_uid: function () {
                return this.uid + '#' + this.ticket;
            },
            readyToStart: function() {
                return this.ready;// && this.guideReady;
            }
        },
        methods:{
            onCommand: function(_json_command){
                if(Object.prototype.hasOwnProperty.call(_json_command, 'command')) {
                    if (_json_command.command === 'NAV') {
                        this.currentnode = this.$refs.pano_view.pano_gotonode(_json_command.node);
                    } else if (_json_command.command === 'VIEW') {
                        this.$refs.pano_view.pano_orient(_json_command.pan, _json_command.tilt);
                    } else if (_json_command.command === 'STARTUSERCOHOST') {
                        if(this.$refs.artc.setCoHost(_json_command.key, _json_command.enable)){
                            this.question_going = _json_command.enable;
                            this.question_wtg = _json_command.enable;
                        }
                    } else if (_json_command.command === 'STOPUSERCOHOST') {
                        if(this.$refs.artc.setCoHost(_json_command.key, _json_command.enable)){
                            this.question_going = _json_command.enable;
                            this.question_wtg = _json_command.enable;
                        }
                    } else if (_json_command.command === 'CONNECT') {
                        this.$refs.artc.connectChannel();
                        this.$refs['welcome-modal'].hide();
                    } else if (_json_command.command === 'DISCONNECT') {
                        this.$refs.artc.leaveChannel();
                    } else if (_json_command.command === 'CHAT') {
                        this.$refs.chatbox.pushMessage(_json_command);
                    } else if (_json_command.command === 'ENDTOUR') {
                        // open modal byebye
                        this.$refs['endtour-modal'].show();
                    }
                }
            },
            registerstream: function(_stream) {
                this.$refs.userlist.setUserStreaming(_stream);
            },
            unregisterstream: function(_stream) {
                this.$refs.userlist.setUserStreaming(_stream, false);
            },
            unregisteruser: function(_id) {
                console.log('++++++++++++++++++++++++', _id);
                if(_id !== this.agora_uid) {
                    this.$refs.userlist.setUserOffline(_id);
                }
            },
            connectRTC (_members){
                if(_members){
                    this.$refs.artc.connectChannel();
                } else {
                    this.$refs.artc.leaveChannel();
                }

                for(const m of _members) {
                    if(m !== this.agora_uid){
                        if(m.indexOf('$') === 0){
                            this.$refs.userlist.addUser(m, m.split('#')[0]);
                        } else {
                            this.$refs.userlist.addUser(m, m.split('#')[0], true);
                        }
                    }
                }
            },
            memberJoin(_id){
                console.log('++++++++++++++++++++++++', _id);
                if(_id !== this.agora_uid){
                    this.$refs.userlist.addUser(_id, _id.split('#')[0]);
                }
            },
            memberLeft(_id){
                console.log('------------------------', _id);
                this.$refs.userlist.setUserOffline(_id);
            },
            endCountdown (){
                if(this.isvalid){
                    this.ready = true;
                    this.resizePanorama();
                }
            },
            startTour () {
                this.stopTestDevice();
                this.$refs.artm.connectChannel();
                this.$refs['welcome-modal'].hide();
            },
            gotDevices (_devices){
                this.audioInputDevices.push({value: _devices[0], text: _devices[0].label});
                /*for(const ai of _devices){
                    this.audioInputDevices.push({value: ai, text: ai.label});
                }*/
            },
            startTestDevice(){
                this.teststream = this.$refs.artc.testDevices("mic-test", this.selectedDevice.deviceId);
                if (this.teststream){
                    this.mictestinterval = setInterval(function(){
                        this.audiotestlevel = this.teststream.getAudioLevel();
                    }.bind(this), 300);
                }
            },
            stopTestDevice(){
                if(this.teststream){
                    this.teststream.close();
                }
                clearInterval(this.mictestinterval);
                this.mictestinterval = null;
            },
            sendChatMessage(_message) {
                let chatmessage = _message;
                chatmessage.command = 'CHAT';
                this.$refs.artm.sendCommand(chatmessage)
            },
            sendinfo(){
                console.log(this.osinfo + ' ' + this.browserinfo, this.$refs.chatbox);
                this.$refs.chatbox.sendChatMessageWithContent(this.osinfo + ' ' + this.browserinfo);
            },
            hostrequest(){
                this.$refs.artm.sendCommand({command:'HOST', user:this.agora_uid})
                this.question_wtg = true;
            }
        },
        mounted(){
            this.$nextTick(() => {
                this.$refs['welcome-modal'].show();
                const browser = Bowser.getParser(window.navigator.userAgent);

                if (browser.satisfies({chrome: '>80' }) || browser.satisfies({edge: '>80' }) || browser.satisfies({firefox: '>70' }) || browser.satisfies({safari: '>12' })){
                    console.log('Satisfies');
                    this.browserOk = true;
                }

                this.osinfo = browser.getOSName() + ' ' + browser.getOSVersion();
                this.browserinfo = browser.getBrowserName() + ' ' + browser.getBrowserVersion() + ' ' + browser.getEngineName();
            })
        }
    }
</script>

<style scoped>

    .img-bg{
        background-size: cover;
        background-position: center;
        padding:0;
        height:100%;
        overflow:auto;
        background-image:
                linear-gradient(rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6)),
                url("../../public/ns_bg.jpg");
        background-blend-mode: lighten;
    }


    .mainrow{
        min-height:80%;
        padding: 0 10px 0 10px;
    }

    .tour-column {
        max-width:1600px;
        max-height:1200px;
        min-width:300px;
        min-height:300px;
    }

    .tour{
        margin-top:5px;
    }

    .tour-container {
        height:calc(100% - 10px);
    }

    #tour-div{
        height: 98%;
        width: 98%;
        margin: auto;
    }

    .panel{
        overflow:hidden;
        background-color:#fff;
        margin:3px;
        padding:5px;
        border-radius:5px;
    }

    .tourbox{
        border: 5px solid transparent;
        outline: 1px solid #000;
        outline-offset: -5px;
    }

    .sidebar-header{
        max-width:100%;
        height:18%;
    }

    .mobile-header{
        height:calc(100% - 5px);
    }

    .toolbox{
        height: 45%;
        max-height: 45%;
    }

    .chatbox{
        height: calc(100% - 35px);
        width: 100%;
        margin-top: 5px;
    }

    .questionbutton{
        width: 100%;
    }

    .help{
        position:absolute;
        top:5px;
        right:5px;
    }

    .sidebar{
        max-width:20%;
        height:100%;
    }

    .sidebar-logo{
        max-width:100%;
        height:100%;
    }

    .tileTitle{
        position: absolute;
        z-index: 1000;
        color: #fff;
        bottom: 3%;
        left: 3%;
        font-weight: bolder;
        text-align: left;
    }

    .systeminfo{
        font-size:0.75em;
        position: absolute;
        width: 95%;
        pointer-events: none;
    }

   @media screen and (max-width: 992px) {

        .sidebar{
            width:100%;
            max-width: 100%;
        }

       /*.tour-container{
           height:100%;
       }*/

        .mainrow{
            /*height:90%;*/
            padding:0;
        }

       .tileTitle{
            font-size: 1.0em;
       }

       /deep/ .modal-body{
           font-size: 0.9em;
           padding: 0.5rem;
       }

       /deep/ .modal-footer{
           font-size: 0.9em;
           padding: 0.5rem;
       }

       h5 {
           text-align: center;
       }

       h3 {
           font-size: 1.3rem;
       }

       .body-content ul {
           padding-inline-start: 20px;
       }
    }

</style>
